// extracted by mini-css-extract-plugin
module.exports = {"basicInfoBackground":"VenueBasicInfo_basicInfoBackground__2PUnJ"};